<template lang="pug">
ul(v-if="errors.has()")
  template(v-for="(messages, attribute) in errors.errors")
    // template(v-for="message in messages")
    li {{attribute}}: {{ messages }}
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {ModelErrors} from 'capitalist-shared/src/core/model';

@Component({
  name: "ModelErrorsList"
})
export default class ModelErrorsList extends Vue {
  @Prop({required: true})
  errors: ModelErrors

}
</script>

<style scoped>

</style>
